import React from "react";
import "./Contact.css";
const Contact = () => {
  return (
    <div className="contact">
      <h1>Email Me</h1>
      <input type="text" placeholder="Name" />
      <input type="text" placeholder="Email" />
      <input type="text" placeholder="Message" className="input-message" />

      <button
        onClick={() => (window.location = "mailto:gbemisolasulaiman@gmail.com")}
      >
        Send
      </button>
    </div>
  );
};

export default Contact;
